/**
 * True when picking another exercise would throw away sets already added.
 * Re-selecting the current exercise is not a switch.
 *
 * @param {{ sets?: unknown[], secondaryValue?: string, exerciseMovement?: string, primary?: string, type?: string }} form
 * @param {{ value?: string, movementPrimary?: string, type?: string } | null | undefined} option
 * @returns {boolean}
 */
export function shouldConfirmExerciseSwitch(form, option) {
  if (!option?.value || !form?.sets?.length) return false;
  const currentValue = form.secondaryValue || form.exerciseMovement || "";
  if (!currentValue) return true;
  return !(
    currentValue === option.value &&
    (form.primary || "") === (option.movementPrimary || "") &&
    (form.type || "") === (option.type || "")
  );
}
